import { useFormState } from 'react-final-form'

import IconTitleGroup from 'common/components/iconTitleGroup'

import LanguageOutputExamples from './languageOutputExamplesField/LanguageOutputExamplesField'
import IsoLanguageField from './IsoLanguageField'
import RuleInstructionField from './RuleInstructionField'

type Props = {
  title: string
  description: string
  isEditMode?: boolean
}

const FormContent = ({ title, description, isEditMode = false }: Props) => {
  const formState = useFormState()
  const { values } = formState

  const selectedRegion = values.region

  return (
    <>
      <div className="flex flex-col text-base-700 pb-5 border-b border-gold-400">
        <div className="text-2xl font-medium font-relais mb-4 px-6 pt-6">
          {title}
        </div>
        <div className="text-sm px-6">{description}</div>
      </div>
      <div className="flex flex-col p-6 overflow-auto h-full">
        <div>
          <IconTitleGroup title="Details" className="mb-4" />
          <IsoLanguageField isEditMode={isEditMode} />
          {selectedRegion && <RuleInstructionField />}
        </div>
        {selectedRegion && (
          <>
            <div className="flex flex-col text-base-700 my-6 border-b border-gold-400" />
            <LanguageOutputExamples />
          </>
        )}
      </div>
    </>
  )
}

export default FormContent
